import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const reservas = {
    layout: {
        listTitle: 'Pockets',
        archivedTitle: 'Archived pockets',
        detailTitle: 'Pocket',
        editTitle: 'Edit pocket',
        newTitle: 'New pocket',
    },
    detail: {
        archiveAccessibility: 'Archive pocket',
        yieldAccessibility: 'Record yield',
        accountLabel: 'Account',
        guaranteesLabel: 'Backs limit of',
        accountFallback: 'Account',
        accountNameFallback: 'your account',
        remainingLabel: 'Remaining',
        deadlineLabel: 'Deadline',
        historyTitle: 'History',
        showLess: 'Show less',
        showAll: 'Show all',
        emptyHistory: 'Nothing saved yet.',
        movementWithdraw: 'Withdrawn',
        movementYield: 'Yield',
        movementDeposit: 'Saved',
        deleteMovementAccessibility: 'Delete movement',
        withdrawButton: 'Withdraw',
        depositButton: 'Save',
        archivedNotice: 'Archived pocket: the amount is frozen and does not count toward Available. To save or withdraw, reactivate it in Goals and Pockets › Archived.',
        accountInactiveNotice: 'The account {{account}} was archived or deleted: this pocket is on hold and comes back with the account.',
        moreOptionsAccessibility: 'More pocket options',
        yieldAction: 'Record yield',
        yieldPill: 'Yield',
        editAction: 'Edit pocket',
        archiveAction: 'Archive pocket',
        deleteAction: 'Delete pocket',
    },
    statement: {
        deposit: 'Saved to pocket',
        withdraw: 'Withdrawn from pocket',
    },
    report: {
        title: 'Pocket report',
        entryTitle: 'Pocket report',
        entryHint: 'How much it earned, month by month',
        previousYear: 'Previous year',
        nextYear: 'Next year',
        yearSummary: 'In {{year}}',
        opening: 'Started the year with',
        deposited: 'Saved',
        withdrawn: 'Withdrawn',
        yielded: 'Yield',
        closingCurrent: 'Today',
        closingPast: 'At the end of {{year}}',
        yieldedAllTime: 'Since the start, this pocket has earned {{amount}}.',
        monthByMonth: 'Month by month',
        monthDeposited: '{{amount}} saved',
        monthWithdrawn: '{{amount}} withdrawn',
        monthYielded: '{{amount}} yield',
        monthEmpty: 'No activity',
    },
    sheet: {
        infoAccessibility: 'What happens to the money',
        backAccessibility: 'Back',
        availableOf: 'Available in {{account}}',
        balanceOf: 'Balance of {{account}}',
    },
    guardarSheet: {
        title: 'Save to pocket',
        amountLabel: 'Amount',
        notesLabel: 'Note (optional)',
        notesPlaceholder: 'E.g. left over this month',
        submit: 'Save',
        reserveAvailable: 'Reserve {{amount}}',
        completeAndReserve: 'Complete and reserve',
        addAndReserve: 'Add to account and reserve',
        overAvailableHint: 'Only {{available}} free in {{account}}. "Complete" puts the missing {{shortfall}} into the account (balance adjustment) and saves it all.',
        overAvailableSubmergedHint: 'Available in {{account}} is negative by {{deficit}}. "Add" puts {{amount}} into the account (balance adjustment) and saves it all; Available stays negative.',
        negativeAvailableHint: 'Available in {{account}} is negative by {{deficit}} and stays that way: the {{amount}} goes in and is saved in full.',
        info: 'The money stays in {{account}}, just set aside. It is not a transfer or an expense: the account total does not change.',
    },
    resgatarSheet: {
        title: 'Withdraw from pocket',
        amountLabel: 'Amount',
        notesLabel: 'Note (optional)',
        notesPlaceholder: 'E.g. needed to use it',
        submit: 'Withdraw',
        all: 'All · {{amount}}',
        info: 'The money does not leave the account: it is no longer set aside and returns to Available in {{account}}.',
    },
    rendimentoSheet: {
        title: 'Record yield',
        modeYield: 'Amount earned',
        modeTotal: 'Current balance',
        derivedYield: 'Earned {{amount}}',
        derivedNoYield: 'Enter more than the {{current}} saved today. To take money out, use Withdraw.',
        notesLabel: 'Note (optional)',
        notesPlaceholder: 'E.g. monthly yield',
        submit: 'Record yield',
        info: 'Enters as income in {{account}} (Investimentos · Juros / Rendimentos) and stays saved here: the account balance goes up and Available does not change. To undo, delete the yield in the pocket history.',
    },
    archiveDialog: {
        title: 'Archive pocket',
        messageWithAmount: 'The {{amount}} goes back to Available in the account. The pocket leaves the list, but you can reactivate it later.',
        messageEmpty: 'The pocket leaves the list. You can reactivate it later.',
        confirm: 'Archive',
    },
    deleteDialog: {
        title: 'Delete pocket',
        message: 'The reserved amount goes back to Available in the account. Are you sure?',
        confirm: 'Delete',
    },
    movementDeleteDialog: {
        title: 'Delete movement',
        message: 'The reserved amount goes back to what it was before this movement. It does not touch any account transaction. Are you sure?',
        messageYield: 'The {{amount}} yield leaves the pocket and its income leaves the account too. Are you sure?',
        confirm: 'Delete',
    },
    archived: {
        frozenAmount: '{{amount}} frozen',
        noAmount: 'No amount',
        accountFallback: 'Account',
        reactivateAccessibility: 'Reactivate {{name}}',
        reactivateButton: 'Reactivate',
        emptyTitle: 'No archived pockets',
        emptySubtitle: 'Archived pockets show up here for you to reactivate whenever you want.',
    },
    blockedDialog: {
        title: 'No free balance to reactivate',
        message: 'Account {{account}} has {{available}} free, but the pocket holds {{frozen}}. How do you want to reactivate?',
        addAndReactivate: 'Add {{amount}} to the account and reactivate',
        reactivateWith: 'Reactivate with {{amount}}',
        reactivateEmpty: 'Reactivate empty',
        cancel: 'Cancel',
    },
} satisfies DeepPartialStrings<TranslationSchema['reservas']>;
